var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592,
    y: 312,
    width: 19,
    height: 19
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20)",
    transform: "translate(-592 -312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.5 313.979C597.344 313.979 593.979 317.344 593.979 321.5 593.979 325.656 597.344 329.021 601.5 329.021 605.656 329.021 609.021 325.656 609.021 321.5 609.021 317.344 605.656 313.979 601.5 313.979ZM601.104 315.958C601.658 315.958 602.094 316.394 602.094 316.948 602.094 317.502 601.658 317.938 601.104 317.938 600.55 317.938 600.115 317.502 600.115 316.948 600.115 316.394 600.55 315.958 601.104 315.958ZM603.479 327.042 599.521 327.042 599.521 325.854 600.906 325.854 600.906 319.917 599.719 319.917 599.719 318.729 602.094 318.729 602.094 319.917 602.094 325.854 603.479 325.854 603.479 327.042Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon2);
export default __webpack_public_path__ + "static/media/infoIcon2.abd541df33a26429ce1a7bc7c3a5500e.svg";
export { ForwardRef as ReactComponent };